<svg
  [attr.viewBox]="viewBox"
  preserveAspectRatio="xMinYMin meet"
  xmlns="http://www.w3.org/2000/svg"
>
  <ng-container *ngFor="let key of connectionsRectByTypeKeys">
    <ng-container *ngFor="let connectiontRect of connectionsRectByType[key]">
      <foreignObject
        [attr.x]="connectiontRect.rect.x"
        [attr.y]="connectiontRect.rect.y"
        [attr.width]="connectiontRect.rect.width"
        [attr.height]="connectiontRect.rect.height"
      >
        <app-dna-syngovia-group-node-card
          [systemDetails]="systemDetails"
          [groupNodeData]="connectiontRect.connection.groupNode"
          [selected]="isCardSelected(connectiontRect.connection.groupNode)"
          (selectedGroupNodeChange)="onSelectedGroupNodeChange($event)"
        ></app-dna-syngovia-group-node-card>
      </foreignObject>
      <ng-container *ngIf="connectiontRect.linePath?.length > 0">
        <path
          class="line line--{{ key }}"
          [attr.d]="connectiontRect.linePath"
        />
      </ng-container>
    </ng-container>
  </ng-container>

  <foreignObject
    [attr.x]="legendX"
    [attr.y]="legendY"
    [attr.width]="legendWidth"
    [attr.height]="legendHeight"
  >
    <app-dna-syngovia-chart-map-legend></app-dna-syngovia-chart-map-legend>
  </foreignObject>
</svg>
